import React from 'react'

import { Button } from '@/components/ui/button'
import { Heading } from '@/components/ui/heading'

const NewUpdateAvailableMessage: React.FC = () => (
  <>
    <Heading size={2}>New update detected</Heading>

    <p className="mb-2">
      {/* The reload should happen in src/main.ts from the vite:preloadError
      event listener */}
      A new update has been detected. Reloading the page...
    </p>

    <p className="mb-0">
      If the page doesn't reload after a few seconds,{' '}
      <Button variant="plain" onClick={() => window.location.reload()}>
        click here
      </Button>
      .
    </p>
  </>
)

export default NewUpdateAvailableMessage
